<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="type === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <div>
        <el-button @click='addKnowledge'>新增知识点2</el-button>
      </div>
      <knowledge-table :tableData="knowledgeList" ></knowledge-table>
    </div>
    </br>
    </br>
    <div>
      <label style="font-size: large;">关联其它知识点,方式，拷贝本题guid，然后到知识点列表中查找到相应知识点，在其后点关联</label>
      </br>
      </br>
      <label style="font-size: large;">本题guid ：{{tmguid}}</label>
    </div>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import knowledgeTable from '@/components/knowledgeTable/knowledgeTable'
  import knowledgeDlg from '@/components/knowledgeDlg'

  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        guid: '',
        tmguid: '',
        id: -1
      }
    },
    computed: {
      ...mapGetters([
        'knowledgeList'
      ]),
      title () {
        return `知识点列表`
      }
    },
    created () {
      // console.log('-----00000000000---------this.tmguid=' + this.tmguid)
      // this.$store.dispatch('actions_getSolutionList', this.tmguid)
    },
    components: {
      knowledgeTable,
      knowledgeDlg
    },
    watch: {
      show: function (val) {
        if (val) {
          this.$store.dispatch('actions_getKLByProblemGuid', this.tmguid)
        }
      }
    },
    methods: {
      addKnowledge () {
        knowledgeDlg({
          isEditData: false,
          tmguid: this.tmguid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// main.vue?00af3867